import { memo } from 'react';
import { useCalendarGrid, useLocale } from 'react-aria';
import { getWeeksInMonth } from '@internationalized/date';
import CalendarCell from '@components/calendar/CalendarCell';
import { CalendarState } from '@react-stately/calendar';
import type { AriaCalendarGridProps } from 'react-aria';



export interface CalendarGridProps extends AriaCalendarGridProps {
	state: CalendarState,
}


const CalendarGrid = (props: CalendarGridProps) => {
	const { state, ...otherProps } = props;
	
	let { locale } = useLocale();
	let { gridProps, headerProps, weekDays } = useCalendarGrid(otherProps, state);
	let weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);

	return (
		<table {...gridProps}>
			<thead {...headerProps}>
				<tr>
					{weekDays.map((day, index) =>
						<th key={index}>
							{day}
						</th>)}
				</tr>
			</thead>
			
			<tbody>
				{[...new Array(weeksInMonth).keys()].map((weekIndex) => 
					<tr key={weekIndex}>
						{state.getDatesInWeek(weekIndex).map((date, i) =>
							date
							? <CalendarCell key={i} state={state} date={date} />
							: <td key={i} />)}
					</tr>)}
			</tbody>
		</table>
	)
}

export default memo(CalendarGrid);